import { useCallback, useEffect, useMemo, useRef, useState } from 'react';

export const FLASH_FADE_IN_MS = 300;
export const FLASH_HOLD_MS = 2000;
export const FLASH_FADE_OUT_MS = 300;
export const FLASH_TOTAL_MS = FLASH_FADE_IN_MS + FLASH_HOLD_MS + FLASH_FADE_OUT_MS;

export interface NarrativeFocusFlash {
    focusedFlashId: number | undefined;
    flashMessage: (id: number) => void;
}

export function useNarrativeFocusFlash(): NarrativeFocusFlash {
    const [focusedFlashId, setFocusedFlashId] = useState<number | undefined>(undefined);
    const timerRef = useRef<ReturnType<typeof setTimeout> | undefined>(undefined);

    const flashMessage = useCallback((id: number): void => {
        if (timerRef.current !== undefined) {
            clearTimeout(timerRef.current);
        }
        setFocusedFlashId(id);
        timerRef.current = setTimeout(() => {
            setFocusedFlashId(undefined);
            timerRef.current = undefined;
        }, FLASH_TOTAL_MS);
    }, []);

    useEffect(function cancelFlashTimerOnUnmount() {
        return () => {
            if (timerRef.current !== undefined) {
                clearTimeout(timerRef.current);
            }
        };
    }, []);

    return useMemo(() => ({ focusedFlashId, flashMessage }), [focusedFlashId, flashMessage]);
}
